import { create } from "zustand";

interface IUserStore {
  userData: Customer | null;
  setUserData: (data: Customer) => void;
}

const useUserStore = create<IUserStore>((set) => ({
  userData: null,
  setUserData: (data) => set(() => ({ userData: data })),
}));

export default useUserStore;
